import { BaseRouteService } from 'core/services';

class TemplateRouteService extends BaseRouteService {
    constructor() {
        super('templates');
    }

    find(filter){
        return super.find(this.base + '/{?patientId,page,rpp,sort}', filter);
    }

    get(id) {
        return super.get(this.base + '/{id}', id);
    }
}

export default TemplateRouteService;